function domingoPascua(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month - 1, day);
}

function toISOFromDate(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

function addDays(date, days) {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
}

const cacheFestivos = new Map();

/** Festivos laborables Catalunya (Stage / Sitges). */
export function festivosCatalunya(year) {
  if (cacheFestivos.has(year)) return cacheFestivos.get(year);
  const set = new Set([
    `${year}-01-01`,
    `${year}-01-06`,
    `${year}-05-01`,
    `${year}-06-24`,
    `${year}-08-15`,
    `${year}-09-11`,
    `${year}-10-12`,
    `${year}-11-01`,
    `${year}-12-06`,
    `${year}-12-08`,
    `${year}-12-25`,
    `${year}-12-26`,
  ]);
  const pascua = domingoPascua(year);
  set.add(toISOFromDate(addDays(pascua, -2)));
  set.add(toISOFromDate(addDays(pascua, 1)));
  cacheFestivos.set(year, set);
  return set;
}

export function formatearFechaCorta(fechaISO) {
  if (!fechaISO) return "—";
  const parts = fechaISO.split("-");
  if (parts.length !== 3) return fechaISO;
  return `${parts[2]}/${parts[1]}`;
}

export function esFinDeSemanaOFiesta(fechaISO) {
  if (!fechaISO) return false;
  const [y, m, d] = fechaISO.split("-").map(Number);
  if (!y || !m || !d) return false;
  const date = new Date(y, m - 1, d);
  const wd = date.getDay();
  if (wd === 0 || wd === 6) return true;
  return festivosCatalunya(y).has(fechaISO);
}
